export default __webpack_public_path__ + "static/media/tier_token_table2.b384ab55.png";